import React from 'react'
import { Stack, SxProps, Theme } from '@mui/material'
import { GridToolbarContainer } from '@mui/x-data-grid'
import { FilterProps } from 'common/AbstractDataGridToolbar/CustomDataGridFilter'
import { ServerFilterProps } from 'common/AbstractDataGridToolbar/CustomDataGridServerFilter'
import { CustomServerSearchbarProps } from 'common/AbstractDataGridToolbar/CustomServerSearchbar'

import RevampedSearchbar from './RevampedSearchbar'
import RevampedServerSearchbar from './RevampedServerSearchbar'
export function SearchToolbar(props: ToolbarProps) {
  const { searchBar, serverSearchBarProps } = props

  let showSearchBar = true
  if (searchBar === 'disabled') {
    showSearchBar = false
  }

  let searchbarComponent = <RevampedSearchbar />
  if (searchBar === 'server') {
    searchbarComponent = (
      <RevampedServerSearchbar
        onSubmit={serverSearchBarProps?.onSubmit}
        onChange={serverSearchBarProps?.onChange}
        options={serverSearchBarProps?.options}
        defaultValue={serverSearchBarProps?.defaultValue}
        handleChange={serverSearchBarProps?.handleChange}
      />
    )
  }

  return (
    <GridToolbarContainer
      sx={{
        width: '100%',
        minHeight: '60px',
        mb: '10px'
      }}
    >
      <Stack direction='row' justifyContent='center' spacing={2} width='100%'>
        <Stack direction='row' justifyContent='space-between'>
          {showSearchBar && searchbarComponent}
        </Stack>
      </Stack>
    </GridToolbarContainer>
  )
}

export interface ToolbarProps {
  filterProps?: FilterProps
  serverFilterProps?: ServerFilterProps
  dateRangePicker?: JSX.Element
  buttons?: JSX.Element
  searchBar?: string
  serverSearchBarProps?: CustomServerSearchbarProps
  filter?: string
  menuSx?: SxProps<Theme>
}
